import React, { useState } from "react";
import { BrowserRouter, NavLink } from "react-router-dom";
import { trimText } from "../../../lib/helpers/trimText";
import { WORKPLACES_ROOT_PATH } from "../../../lib/routes/routes";
import { Icon } from "../../shared/Icon/Icon";
import { MarkerStatus } from "./MarkerStatus";
import { MarkerStatuses } from "../lib/useMarkerData";
import { RadioButton } from "../../shared/RadioButton/RadioButton";

import "./Popup.scss";

interface Props {
  id: string;
  type: string;
  user: string;
  onClick?: () => void;
  isBlocked?: boolean;
  location?: string;
  name?: string;
  tooltipAlignment?: boolean;
  labelAlignment?: string;
  onAlignmentChange?: (roomId: string, alignment: string) => void;
}

const DEFAULT_ROOM_LABEL_ALIGNMENT = "center";

const ROOM_LABEL_ALIGNMENT_OPTIONS = [
  { label: "Top", value: "top" },
  { label: "Center (default)", value: DEFAULT_ROOM_LABEL_ALIGNMENT },
  { label: "Center - rotated 45°", value: "center-rotated" },
  { label: "Bottom", value: "bottom" },
];

export const Popup = ({
  name,
  location,
  isBlocked,
  id,
  type,
  user,
  tooltipAlignment,
  labelAlignment,
  onAlignmentChange,
}: Props) => {
  const hasUser = !!user?.length;
  const [selectedAlignment, setSelectedAlignment] = useState(
    labelAlignment || DEFAULT_ROOM_LABEL_ALIGNMENT
  );

  const defineStatus = () => {
    if (isBlocked) {
      return MarkerStatuses.BLOCKED;
    }

    return MarkerStatuses.ASSIGNED;
  };

  const handleAlignmentChange = (
    event: React.ChangeEvent<HTMLInputElement>
  ) => {
    const newAlignment = event.target.value;
    setSelectedAlignment(newAlignment);
    if (onAlignmentChange) {
      onAlignmentChange(id, newAlignment);
    }
  };

  return (
    <div className="Popup">
      <div className="Popup__head">
        <span className="Popup__name">{trimText(name || "", 25)}</span>
        {location && <span className="Popup__location">{location}</span>}
      </div>
      <div className="Popup__content">
        {(hasUser || isBlocked) && <MarkerStatus status={defineStatus()} />}

        {hasUser && (
          <div className="Popup__user flex-a-center">
            <Icon icon="single-user-thin" />
            <span className="pl-min">{user} (Assignee)</span>
          </div>
        )}

        <BrowserRouter>
          <NavLink
            to={`${WORKPLACES_ROOT_PATH}/${type.toLowerCase()}/${id}`}
            className="Popup__settings flex-a-center"
          >
            <Icon icon="settings" />
            <span>Open settings</span>
          </NavLink>
        </BrowserRouter>

        {tooltipAlignment && (
          <div className="Popup__alignment">
            <span className="Popup__alignmentTitle">
              Vertical room label alignment (shape only)
            </span>

            <div className="Popup__alignmentOptions">
              {ROOM_LABEL_ALIGNMENT_OPTIONS.map(({ label, value }) => (
                <RadioButton
                  key={value}
                  title={label}
                  value={value}
                  name="vertical-room-label-alignment"
                  checked={selectedAlignment === value}
                  onChange={handleAlignmentChange}
                  className="Popup__alignmentOption"
                />
              ))}
            </div>
          </div>
        )}

        {/* <Button
          onClick={() => onClick && onClick()}
          title="Remove from map"
          size="small"
          color="primary"
        /> */}
      </div>
    </div>
  );
};
